<app-navbar (sideBarStatus)="openSideBar($event)"> </app-navbar>
<app-side-bar [status]="sideBar"><router-outlet></router-outlet></app-side-bar>
